import { generateTestId } from "@client-shared";

export const setTopProductsChartTestId = (identifier: string): string =>
  generateTestId("TopProductsChart", identifier);

// Specific element testIds
export const setTopProductsChartContainerTestId = (): string =>
  setTopProductsChartTestId("container");

export const setTopProductsChartTitleTestId = (): string =>
  setTopProductsChartTestId("title");
